import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import PacketPage from '../components/PacketPage';

class PacketOfAgent extends Component {
  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.agentSites(callback)
      },
      fetchPackets: (params, callback) => {
        DataFetcher.agentPackets(
          params, 
          {
            success: callback
          }
        )
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(params, {
          success: callback
        })
      },
      createPacket: (params, callback, completed) => {
        DataFetcher.createPacket(
          params, 
          {
            success: callback,
            completed
          }
        )
      },
      updatePacket: (params, callback, completed) => {
        DataFetcher.updatePacket(
          params, 
          {
            success: callback,
            completed
          }
        )
      },
      deletePacket: (params, callback) => {
        DataFetcher.deletePacket(
          params.id, 
          {
            success: callback
          }
        )
      }
    }

    return <PacketPage {...pageProps}/>
  }
}

export default PacketOfAgent;


// WEBPACK FOOTER //
// ./src/modules/PacketOfAgent.js